/* RWYS 2026 - minimal theme behaviours */
(function () {
  'use strict';

  /* ---- Mobile navigation ---- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-mobile-nav]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        drawer.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---- Duplicate marquee content so the loop is seamless ---- */
  document.querySelectorAll('[data-marquee]').forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  /* ---- Smooth-scroll to in-page anchors, accounting for sticky header ---- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (id.length < 2) return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('.site-header');
    var offset = header ? header.offsetHeight + 12 : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  /* ---- Scroll to a form that just returned a message ---- */
  var msg = document.querySelector('.form-msg');
  if (msg && window.location.hash) {
    setTimeout(function () {
      msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 60);
  }
})();
